/**
 * BulkDeleteBar Component
 *
 * Fixed bar at the bottom when insights are selected:
 * - Shows count of selected insights
 * - Delete button with confirmation dialog
 */

import { useState } from 'react';
import { Trash2, X, AlertTriangle, Loader2 } from 'lucide-react';

export default function BulkDeleteBar({
  selectedCount,
  onDelete,
  onClear,
  isDeleting,
}) {
  const [showConfirm, setShowConfirm] = useState(false);

  if (selectedCount === 0) return null;

  const handleDelete = async () => {
    await onDelete();
    setShowConfirm(false);
  };

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40">
      <div className="bg-gray-800 border border-gray-600 rounded-lg shadow-2xl px-4 py-3 flex items-center gap-4">
        {showConfirm ? (
          <>
            <AlertTriangle className="w-5 h-5 text-amber-400" />
            <span className="text-sm text-gray-200">
              Delete {selectedCount} insight{selectedCount !== 1 && 's'}?
            </span>
            <button
              onClick={handleDelete}
              disabled={isDeleting}
              className="px-3 py-1.5 bg-red-600 hover:bg-red-500 text-white text-sm rounded-md flex items-center gap-1 disabled:opacity-50"
            >
              {isDeleting ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                <Trash2 className="w-4 h-4" />
              )}
              Confirm
            </button>
            <button
              onClick={() => setShowConfirm(false)}
              disabled={isDeleting}
              className="px-3 py-1.5 bg-gray-700 hover:bg-gray-600 text-gray-300 text-sm rounded-md"
            >
              Cancel
            </button>
          </>
        ) : (
          <>
            <span className="text-sm text-gray-200">
              <span className="font-semibold text-indigo-400">{selectedCount}</span>
              {' '}insight{selectedCount !== 1 && 's'} selected
            </span>
            <button
              onClick={() => setShowConfirm(true)}
              className="px-3 py-1.5 bg-red-600/20 hover:bg-red-600 text-red-400 hover:text-white text-sm rounded-md flex items-center gap-1 transition-colors"
            >
              <Trash2 className="w-4 h-4" />
              Delete
            </button>
            <button
              onClick={onClear}
              className="p-1.5 hover:bg-gray-700 text-gray-500 hover:text-gray-300 rounded-md transition-colors"
              title="Clear selection"
            >
              <X className="w-4 h-4" />
            </button>
          </>
        )}
      </div>
    </div>
  );
}
